"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsToast = void 0;
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
exports.SmlsToast = ({ id, icon, title, content = 'Content', hasCloseButton = true, isVisible = true, timeAlive = 5000, }) => {
    const [isOpen, setIsOpen] = react_1.useState(isVisible);
    react_1.useEffect(() => {
        if (isOpen) {
            setTimeout(() => {
                setIsOpen(false);
            }, timeAlive);
        }
    }, [isOpen]);
    return (react_1.default.createElement(reactstrap_1.Toast, { id: id, isOpen: isOpen },
        icon,
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, title),
            react_1.default.createElement("p", null, content)),
        hasCloseButton && (react_1.default.createElement("button", { type: "button", onClick: () => setIsOpen(false) },
            react_1.default.createElement("i", { className: "material-icons" }, "close")))));
};
//# sourceMappingURL=index.js.map